import { render, staticRenderFns } from "./demandrecAddOrEdit.vue?vue&type=template&id=0c580442&scoped=true"
import script from "./demandrecAddOrEdit.vue?vue&type=script&lang=js"
export * from "./demandrecAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./demandrecAddOrEdit.vue?vue&type=style&index=0&id=0c580442&prod&lang=scss"
import style1 from "./demandrecAddOrEdit.vue?vue&type=style&index=1&id=0c580442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c580442",
  null
  
)

export default component.exports